import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-matrix-webapp',
  standalone: true,
  imports: [],
  templateUrl: './matrix-webapp.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './matrix-webapp.component.scss'
})
export class MatrixWebappComponent implements OnInit {
  trustedNextAppUrl!: SafeResourceUrl;
  
  // Get the domain from environment configuration
  private nextJsDomain = environment.externalApps.matrixUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    // Essential: bypass security to load the external URL
    this.trustedNextAppUrl = 
      this.sanitizer.bypassSecurityTrustResourceUrl(this.nextJsDomain);
  }

  /**
   * Optional: Send messages to the embedded Next.js app
   * @param data The data to send to the Next.js app
   */
  sendMessageToNextApp(data: any): void {
    const iframe = document.querySelector('.embedded-next') as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(
        data,
        this.nextJsDomain // Target origin for security
      );
    }
  }

  /**
   * Optional: Listen for messages from the embedded Next.js app
   * Call this in ngOnInit if you need cross-iframe communication
   */
  private listenForMessages(): void {
    window.addEventListener('message', (event) => {
      // CRITICAL: Verify the origin is your Next.js app's domain
      if (event.origin !== this.nextJsDomain) {
        return;
      }
      
     
      // Process event.data here
    });
  }
}
